import {
    ECJuridicalType,
    ECLegalForm,
    ECSubjectType,
    EnergyCommunity,
    EnergyCommunityNamedPod,
    HierarchyEntity
} from 'smag-commons/cfg/hierarchy';
import {ECMemberIdRelation} from '../../../shared/ec-members';

export interface FormCommunity {
    community: EnergyCommunity;
    communityData: HierarchyEntity;
}

export interface MembersInfo {
    rangeTakenBy: MemberInfo | null; // whether this range is currently taken by some other member
    members: MemberInfo[]; // sorted members (may include the current one in case of update)
}

export interface MemberInfo extends ECMemberIdRelation {
    memberName?: string; // only available if user has enough permissions
}

export interface Document {
    name: string;
    documentId?: string; // only defined if already existing before the current session
    file?: File; // only defined if uploaded during the current session
}


export interface MemberForConfig {
    juridical_type: ECJuridicalType;
    legal_form: ECLegalForm;
    subject_type: ECSubjectType;
}


export interface PodInfo {
    podResource?: EnergyCommunityNamedPod; // POD resource
    membersInfo?: MembersInfo; // information about *currently* related member(s)
}

export interface EditedDocument {
    documentId?: string; // in case we are overwriting an already existing document
    documentType: string;
    metadata?: object; // used for some types of documents
    expiration?: number;
    file?: File; // uploaded file
}


export interface PropertyUnitTriplet {
    sheet: string;
    particle: string;
    subdivision: string;
}

export type MemberRange = [start?: number, end?: number];

export enum PropertyUnitFormError {
    LOCAL_DUPLICATE_PROPERTY_UNITS = 'local_duplicate_property_units',
    DUPLICATE_PROPERTY_UNITS = 'duplicate_property_units',
    INVALID_RANGE = 'invalid_range',
    INVALID_START_DATE = 'invalid_start_date',
    INVALID_END_DATE = 'invalid_end_date'
}
